var map = {
	"app/views/pages/apps/masters/masters.module": [
		"./src/app/views/pages/apps/masters/masters.module.ts",
		"app-views-pages-apps-masters-masters-module"
	],
	"app/views/pages/apps/transactions/transactions.module": [
		"./src/app/views/pages/apps/transactions/transactions.module.ts",
		"app-views-pages-apps-transactions-transactions-module"
	],
	"app/views/pages/auth/auth.module": [
		"./src/app/views/pages/auth/auth.module.ts"
	],
	"app/views/pages/dashboard/dashboard.module": [
		"./src/app/views/pages/dashboard/dashboard.module.ts",
		"app-views-pages-dashboard-dashboard-module"
	],
	"app/views/reports/reports.module": [
		"./src/app/views/reports/reports.module.ts",
		"app-views-reports-reports-module"
	],
	"app/views/themes/demo1/theme.module": [
		"./src/app/views/themes/demo1/theme.module.ts",
		"app-views-themes-demo1-theme-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;